import { PaginationListType } from '../../../Types/PaginationParams';
import ConfigSelectorSection from './ConfigSelectorSection';

interface BaseConfig {
    identifier: string;
    title: string;
}

interface ConfigItem {
    identifier: string;
    title: string;
    description: string;
    config?: BaseConfig;
}

interface ConfigSelectorProps {
    configs: BaseConfig[];
    selectedItems: string[];
    onToggleItem: (itemId: string) => void;
    i18n: any;
    placeholders: {
        search: string;
        empty: string;
    };
    itemsFunction: (
        configIdentifier: string,
        page: number,
        itemsPerPage: number,
        query?: string | null,
    ) => Promise<{ data: { data: ConfigItem[]; total: number } }>;
    getListType: (configIdentifier: string) => PaginationListType;
}

function ConfigSelector({
    configs,
    selectedItems,
    onToggleItem,
    i18n,
    placeholders,
    itemsFunction,
    getListType,
}: ConfigSelectorProps) {
    return (
        <>
            <div className="mb-6 text-sm text-gray-500">
                {selectedItems?.length || 0} {i18n.translate({ id: 'selector.selected', sourceName: 'PromptFunction' })}
            </div>

            <div className="space-y-0">
                {configs.map((config) => (
                    <ConfigSelectorSection
                        key={config.identifier}
                        config={config}
                        selectedItems={selectedItems}
                        onToggleItem={onToggleItem}
                        i18n={i18n}
                        itemsFunction={itemsFunction}
                        getListType={getListType}
                    />
                ))}
            </div>
        </>
    );
}

export default ConfigSelector;
